import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangePasswordModel } from '../model/FormsEntity/resetPassword';
import { UserManagementService } from '../service/userManagement.service';
import { NotificationService } from '../core/core.module';
@Component({
  selector: 'app-forgot-reset-pass',
  templateUrl: './forgot-reset-pass.component.html',
  styleUrls: ['./forgot-reset-pass.component.css']
})
export class ForgotResetPassComponent {
  changePass:ChangePasswordModel = new ChangePasswordModel();
  userId:string = null;
  userIdInt:number = null;
  newPass:string ;
  conformPass:string ;
  wrongPass:boolean = false;
  resetPassForm = this.fb.group({
    roleId:null,
    otp:[null,Validators.compose([
      Validators.required,Validators.pattern('^[0-9]*$')
    ])],
    newPassword:[null,Validators.compose([
      Validators.required
    ])],
    conformPassword:[null,Validators.compose([
      Validators.required
    ])],
  });

  
  constructor(
    private fb: FormBuilder,
    private userMenage :UserManagementService,
    private router: Router,
    private notification:NotificationService) {}

  ngOnInit(){
    this.userId = sessionStorage.getItem('userId');
    this.userIdInt = +this.userId;
    this.changePass.userId = this.userIdInt;
      // console.log(this.userIdInt)
  }

  checkPassword(){
    if(this.newPass === this.conformPass){
      this.wrongPass = false;
    }
  }

  onSubmit(): void  {
    if (this.resetPassForm.invalid) {
      return;
      } 
    if(this.newPass != this.conformPass){
      this.wrongPass = true;
      return;
    }  
    this.userMenage.changePasswordService(this.changePass).subscribe(data =>{
      // console.log(data)
      if(data && data.error){
        this.notification.warn(data.error.errorMessage);
      }else if(data && data.status){
        this.notification.success(data.status.detailMessage);
        this.router.navigate(['/login'])
        sessionStorage.removeItem('invalidcount');
      }
      
    }
    )
  }
}
